import script from "./old_index.vue?vue&type=script&setup=true&lang=js"
export * from "./old_index.vue?vue&type=script&setup=true&lang=js"

import "./old_index.vue?vue&type=style&index=0&id=7428be20&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7428be20"]])

export default __exports__